module.exports = __webpack_public_path__ + "assets/images/logo-526081af12e78e0f861cb908404d8e4c.png";